import { api } from "@/lib/api";
import { BaseService } from "./base.service";
import { ApiError, ApiResponse } from "@/interfaces/api.interface";

export class NotificationService extends BaseService {
  constructor() {
    super("Notification");
  }

  async markViewed(userId: string): Promise<ApiResponse<boolean>> {
    try {
      const res = await api.put(`${process.env.REACT_APP_BASE_URL}/api/Notification/mark-viewed/${userId}`);

      if (res.ok) {
        return { data: true, error: null };
      }

      return { data: null, error: res.data as ApiError };
    } catch (error) {
      return { data: null, error: error as ApiError };
    }
  }
}

export const notificationSvc = new NotificationService();
